import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SimpleInput from 'dpl/form/components/SimpleInput';

const TRANSFERABLE_STYLES = [
  'fontFamily',
  'fontSize',
  'fontStyle',
  'fontWeight',
  'letterSpacing',
  'textTransform'
];

export default class AutosizeInput extends Component {
  static propTypes = {
    className: PropTypes.string,
    inputClassName: PropTypes.string,
    maxWidth: PropTypes.string,
    onAutosize: PropTypes.func,
    placeholder: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  };

  static defaultProps = {
    className: null,
    inputClassName: null,
    maxWidth: null,
    onAutosize: null,
    placeholder: null,
    value: null
  };

  state = { inputWidth: 0 };

  _isMounted = false;

  inputRef = createRef();
  sizerRef = createRef();

  componentDidMount() {
    this._isMounted = true;
    this.copyStylesIfNeeded();
    this.updateInputWidthIfNeeded();
  }

  componentDidUpdate(_, prevState) {
    if (prevState.inputWidth !== this.state.inputWidth) {
      this.props.onAutosize && this.props.onAutosize();
    }

    this.updateInputWidthIfNeeded();
  }

  copyStylesIfNeeded = () => {
    if (!this._isMounted || !this.inputRef.current || !this.sizerRef.current) {
      return;
    }

    const inputStyles = window.getComputedStyle(this.inputRef.current);
    if (!inputStyles) {
      return;
    }

    TRANSFERABLE_STYLES.forEach(styleName => {
      this.sizerRef.current.style[styleName] = inputStyles[styleName];
    });
  };

  updateInputWidthIfNeeded = () => {
    if (!this._isMounted) {
      return;
    }

    const inputWidth = this.sizerRef.current.scrollWidth;
    if (inputWidth !== this.state.inputWidth) {
      this.setState({ inputWidth });
    }
  };

  render() {
    const {
      className,
      inputClassName,
      maxWidth,
      onAutosize: _,
      ...inputProps
    } = this.props;

    return (
      <div className={classnames('AutosizeInput', className)}>
        <SimpleInput
          className={classnames(
            'AutosizeInput__input tr',
            className,
            inputClassName
          )}
          ref={this.inputRef}
          style={{
            boxSizing: 'content-box',
            maxWidth,
            width: `${this.state.inputWidth}px`
          }}
          {...inputProps}
        />
        <div
          className="absolute left-0 top-0 v-hidden overflow-scroll pre"
          ref={this.sizerRef}
        >
          {this.props.value || this.props.placeholder}
        </div>
      </div>
    );
  }
}
